export default "__VITE_ASSET__DaafLNUF__"